// 新增禁飞区按钮对应的路由
export const addNoFlyZone = {
    path: 'add',
    name: 'AddNoFlyZone',
    hidden: true,
    meta: {
        title: 'addNoFlyZone',
        activeMenu: '/no-fly-zone-manage/index'
    },
    component: () => import('@/views/no-fly-zone-manage/no-fly-zone')
}

// 编辑禁飞区按钮对应的路由
export const editNoFlyZone = {
    path: 'edit/:id',
    name: 'EditNoFlyZone',
    props: true,
    hidden: true,
    meta: {
        title: 'editNoFlyZone',
        activeMenu: '/no-fly-zone-manage/index'
    },
    component: () => import('@/views/no-fly-zone-manage/no-fly-zone')
}

// 新建/编辑 任务按钮对应的路由
export const addTaskSpot = {
    path: 'spot',
    name: 'AddTaskSpot',
    hidden: true,
    meta: {
        title: 'addTaskSpot',
    },
    component: () => import('@/views/task-manage/spot')
}
export const editTaskSpot = {
    path: 'spot/:id',
    name: 'EditTaskSpot',
    hidden: true,
    props: true,
    meta: {
        title: 'editTaskSpot',
    },
    component: () => import('@/views/task-manage/spot')
}
export const addTaskArea = {
    path: 'area',
    name: 'AddTaskArea',
    hidden: true,
    meta: {
        title: 'addTaskArea',
    },
    component: () => import('@/views/task-manage/area')
}
export const editTaskArea = {
    path: 'area/:id',
    name: 'EditTaskArea',
    hidden: true,
    props: true,
    meta: {
        title: 'editTaskArea',
    },
    component: () => import('@/views/task-manage/area')
}
export const addTaskOrthophoto = {
    path: 'orthophoto',
    name: 'AddTaskOrthophoto',
    hidden: true,
    meta: {
        title: 'addTaskOrthophoto',
    },
    component: () => import('@/views/task-manage/orthophoto')
}
export const editTaskOrthophoto = {
    path: 'orthophoto/:id',
    name: 'EditTaskOrthophoto',
    hidden: true,
    props: true,
    meta: {
        title: 'editTaskOrthophoto'
    },
    component: () => import('@/views/task-manage/orthophoto')
}
export const addTaskObliquePhotography = {
    path: 'oblique-photography',
    name: 'AddTaskObliquePhotography',
    hidden: true,
    meta: {
        title: 'addTaskObliquePhotography',
    },
    component: () => import('@/views/task-manage/oblique-photography')
}
export const editTaskObliquePhotography = {
    path: 'oblique-photography/:id',
    name: 'EditTaskObliquePhotography',
    hidden: true,
    props: true,
    meta: {
        title: 'editTaskObliquePhotography'
    },
    component: () => import('@/views/task-manage/oblique-photography')
}
export const addTaskLogistics = {
    path: 'logistics',
    name: 'AddTaskLogistics',
    hidden: true,
    meta: {
        title: 'addTaskLogistics',
    },
    component: () => import('@/views/task-manage/logistics')
}
export const editTaskLogistics = {
    path: 'logistics/:id',
    name: 'EditTaskLogistics',
    hidden: true,
    props: true,
    meta: {
        title: 'editTaskLogistics'
    },
    component: () => import('@/views/task-manage/logistics')
}

export const addTaskArr = [addTaskSpot, addTaskArea, addTaskOrthophoto, addTaskObliquePhotography, addTaskLogistics]
export const editTaskArr = [editTaskSpot, editTaskArea, editTaskOrthophoto, editTaskObliquePhotography, editTaskLogistics]

export const taskAchievementDisplay = {
    path: '/achievement-display/:id',
    name: 'TaskAchievementDisplay',
    hidden: true,
    props: true,
    meta: {
        title: 'taskAchievementDisplay',
    },
    component: () => import('@/views/admin/history/flyplay')
}

// 自动审批
export const AutoApproval = {
    path: 'auto-approval',
    name: 'AutoApproval',
    hidden: true,
    meta: {
        title: 'autoApproval',
        activeMenu: '/approval-manage/index'
    },
    component: () => import('@/views/approval-manage/auto-approval')
}

/* 设备管理 */
// rtk详情
export const RTKInfo = {
    path: 'rtk/:id',
    name: 'RTKInfo',
    hidden: true,
    props: true,
    meta: {
        title: 'rtkInfo',
        activeMenu: '/device-manage/index'
    },
    component: () => import('@/views/device-manage/rtk')
}

export const WeatherStationInfo = {
    path: 'weather-station/:id',
    name: 'WeatherStationInfo',
    hidden: true,
    props: true,
    meta: {
        title: 'weatherStationInfo',
        activeMenu: '/device-manage/index'
    },
    component: () => import('@/views/device-manage/weather-station')
}

export const deviceInfoArr = [RTKInfo, WeatherStationInfo]